module.exports = __webpack_public_path__ + "static/antelligencec-37252b8e5f46f0aafa58fab3a707473d.png";